import {EntityData} from "./entity/entity.data";
import {LocalisableEntityData} from "./entity/localisable-entity.data";
import {BehaviorSubject, Observable, Subject} from "rxjs";

/**
 *  Base model class that holds an EntityData. It holds the data that will be used as a parameter for the report and provides the method to generate a report.
 */
export abstract class DataResourceModel<T extends EntityData<T>> {

    /**
     * Define the data for the model.
     */
    public data: T;

    /**
     * Define that the entity is read only
     */
    protected _readonly: boolean = false;
    protected _$readonlyChange: Subject<boolean> = new BehaviorSubject(false);
    public $readonlyChange: Observable<boolean> = this._$readonlyChange.asObservable();


    constructor(public dataType: typeof EntityData) {
    }

    /**
     * Retrieves the name of the model
     * @returns {string}
     */
    protected getModelName(): string {
        return this.constructor.name.replace(/^_/, "");
    }

    /**
     * Retrieves the kebab case name of the model which is in a format that matches the naming convention of
     * the server side resource
     * @returns {string} Name of this model
     */
    protected getResourceName(): string {
        return this.getModelName()
            .replace(/Model$/, "")
            .replace(/Entity$/, "")
            .replace(/\.?([A-Z])/g, (x, y) => "-" + y.toLowerCase())
            .replace(/^-/, "");
    }

    public abstract getResource(): string;

    get readonly(): boolean {
        return this._readonly;
    }

    set readonly(value: boolean) {
        this._readonly = value;
        this._$readonlyChange.next(value);
    }

    /**
     * Returns if the model is dealing with a localisable entity.
     * Checks if the type is an LocalisableEntityData to determine if the entity is localisable.
     * @returns {boolean}
     */
    isEntityLocalisable(): boolean {
        let entityObj = this.dataType;
        while (entityObj != null) {
            if (Object.getPrototypeOf(entityObj) === LocalisableEntityData) {
                return true;
            }
            entityObj = Object.getPrototypeOf(entityObj)
        }
        return false;
    }

    /**
     * Returns the version of the resource.
     * @returns {number}
     */
    getResourceVersion(): number {
        return 0;
    }
}
